<packbo-dynamic-page [blocks]="blocks()" />
